import { render, staticRenderFns } from "./staff-add.vue?vue&type=template&id=ecf107f4&scoped=true&"
import script from "./staff-add.vue?vue&type=script&lang=js&"
export * from "./staff-add.vue?vue&type=script&lang=js&"
import style0 from "./staff-add.vue?vue&type=style&index=0&id=ecf107f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf107f4",
  null
  
)

export default component.exports